import {
  DARK_TEXT_COLOUR,
  getPerceivedBubbleColour,
  LIGHT_TEXT_COLOUR,
} from '@/components/public/Visualisations/NestedBubbles'
import typedStore from '@/store/typedStore'
import { VisTreeNode } from '@/types'
import { ColorTranslator } from 'colortranslator'
import { HierarchyCircularNode } from 'd3-hierarchy'

const DEFAULT_STORY_COLOUR = 'black'

export class NestedBubbleMetadata {
  private _node: HierarchyCircularNode<VisTreeNode>
  maxDisplayLevel: number
  filterLuminosity: number
  userZoomScale: number

  constructor(
    node: HierarchyCircularNode<VisTreeNode>,
    maxDisplayLevel: number,
    filterLuminosity: number,
    userZoomScale: number,
  ) {
    this._node = node
    this.maxDisplayLevel = maxDisplayLevel
    this.filterLuminosity = filterLuminosity
    this.userZoomScale = userZoomScale
  }

  get visNode() {
    return this._node.data
  }

  get path() {
    return this.visNode.path
  }

  get radius() {
    return this._node.r
  }

  get position() {
    return {
      x: this._node.x,
      y: this._node.y,
    }
  }

  get level() {
    return this.visNode.level
  }

  get isTranslucent() {
    return this.visNode.isTranslucent
  }

  get storyColour() {
    const colour = new ColorTranslator(this.visNode.colour ?? DEFAULT_STORY_COLOUR)
    if (this.isTranslucent) {
      colour.setL(this.filterLuminosity)
    }
    return colour.HEX
  }

  get fontColour() {
    const bubbleColour = getPerceivedBubbleColour(this.storyColour, this.level)
    return bubbleColour.L > 50 ? this._darkTextColour : LIGHT_TEXT_COLOUR
  }

  get isLeafLevel() {
    // default to true to handle nodes from map view as they may not have a path but we want to display leaf level data
    return this.level === typedStore.activeVisualisation.leafLevel ?? true
  }

  get label() {
    if (this.isLeafLevel) {
      const labelField =
        typedStore.activeVisualisation.visualisationStore.app.config.appConfig.projectLabelField
      return labelField && this.visNode.data ? this.visNode.data[labelField] : ''
    } else {
      return this.visNode.name
    }
  }

  private get _darkTextColour() {
    const colour = new ColorTranslator(DARK_TEXT_COLOUR)
    if (this.isTranslucent) {
      colour.setL(this.filterLuminosity)
    }
    return colour.HEX
  }
}
